import React from 'react';
import Web3Template from '../components/Connect/Web3/index';

function index() {
  return <Web3Template />;
}

export default index;
